import React, { useEffect, useMemo, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import AddLocation from "@components/list-management/add-location-more";
import "./choicelist.scss";
import { getValue } from "@utils/lodash";
import { useNavigate } from "react-router-dom";
import Loader from "@components/common/Loader";
import NoAccessPage from "@components/common/NoAccess";
import AddEntity from "./popup/add-entity";
import {
  deleteSpecificChildEntityGroup,
  deleteSpecificEntityGroup,
  getChildEntityGroups,
  getEntityGroups,
  updateChildEntityGroup,
  updateChildEntityGroupStatus,
} from "@services/entity-mapping.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import AddChildGroupEntity from "./popup/add-child-entity";
import EntityMappingOptions from "@components/entity-mapping";
import PaginationPage from "@components/pagination/pagination";
import Search from "@components/common/Search";
import BulkUploadDropdown from "@components/BulkUploadDropdown";
import { exportEntityMapping } from "@services/import.service";
import BulkDownloadDropdown from "@components/BulkDownloadDropdown";
import ConfigEntityNotfound from "@components/Page-Not-Found/config-entity-not-found";
import MoreConfigSvgComponent from "../../assets/svg-components/left-menu/more-config";
import { debounceSearch } from "@_common/common-helper";

interface IEntityMappingProps {}

const EntityMapping: React.FunctionComponent<IEntityMappingProps> = (
  props: any
) => {
  let navigate = useNavigate();
  const [dropdownOptions] = useState([
    { value: "ENTITY_MAPPING", label: "Entity Mapping" },
  ]);

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = useState(true);
  const [isLoading1, setIsLoading1] = useState(true);

  const [headerList, setHeaderList] = useState([]);

  const [isOpen, setIsOpen] = useState(false);
  const [editHeader, setEditHeader] = useState(false);
  const [paginationObj, setPaginationObj] = useState<any>({});

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getHeaderList();
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      // getHeaderList();
      debouncedSearch();
      // getEntityList();
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getHeaderList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getEntityGroups(queryRequest);
      if (resp) {
        setHeaderList(getValue(resp, `data.entityGroups`, []));
        let list =
          Object.values(params).length > 0 ? Object.values(params) : [];
        if (getValue(list, `length`, 0) > 0) {
          getEntityList(
            getValue(params, `level1`, "").split("_")[1],

            `level${getValue(
              resp,
              `data.entityGroups[${0}].group_level`,
              ""
            )}` === `level1`
              ? ""
              : getValue(params, `level1`, "").split("_")[0]
          );
          list.map((item: any, _index: number) => {
            let findNextLevelInfo = getValue(
              resp,
              `data.entityGroups`,
              []
            ).filter(
              (ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
            );
            return getEntityList(
              getValue(findNextLevelInfo, `[${0}].id`, ""),
              item.split("_")[0]
            );
          });
        } else {
          getEntityList(
            getValue(resp, `data.entityGroups[${0}].id`, ""),

            null
          );
        }

        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const debouncedSearch = useMemo(() => debounceSearch(getHeaderList, 500), []);

  const [childEntityList, setChildEntityList] = useState<any>({});

  const getEntityList = async (id: string, entity_parent: any) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let levelObj: any = {};
    let length = Object.values(params).length;
    for (let i = 0; i < length ? length : 0; i++) {
      let level = params[`level${i + 1}`].split("_")[1];
      if (level == id) {
        levelObj[`level${i + 1}`] = level;
      }
    }
    let key = Object.keys(levelObj)[0];
    let pagination: any = key && params[key].split("_");

    if (id) {
      let payload = {
        entity_group: id,
        entity_parent: entity_parent,
        page_no: getValue(pagination, `[${3}]`, 1),
        page_size: getValue(pagination, `[${4}]`, 10),
        search_text: getValue(pagination, `[${5}]`, ""),
      };
      let queryRequest = QueryRequestHelper(payload);
      setIsLoading1(true);
      try {
        let resp = await getChildEntityGroups(queryRequest);
        if (resp) {
          childEntityList[id] = getValue(resp, `data.entityMapping`, []);
          paginationObj[id] = getValue(resp, `data.pagination.total`, 0);
          setParent_index(null);
          setParent_info({});
          setEditEntity(false);
          setIsLoading1(false);
          setChildEntityList({ ...childEntityList });
        } else {
          setIsLoading1(false);
        }
      } catch (error) {
        setIsLoading1(false);
      }
    } else {
      // toast.error("You have Reached Maximum Levels");
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const handleModalCancel = () => {
    handleModal();
  };
  const handleEditHeader = () => {
    setEditHeader(!editHeader);
  };
  const handleEditGroupHeader = () => {
    setEditHeader(true);
    handleModal();
  };

  /* -------------------------------------------------------------------------- */
  /*                                Delete section                              */
  /* -------------------------------------------------------------------------- */
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [deleteValue, setDeleteValue] = useState("");
  const handleDeleteModal = (item: any) => {
    if (getValue(item, `id`, "")) {
      setDeleteId(getValue(item, `id`, ""));
      setDeleteValue(getValue(item, `group_name`, ""));
    }
    setDeleteOpen(!deleteOpen);
  };
  const handleDeleteFun = async () => {
    try {
      let resp = await deleteSpecificEntityGroup(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setDeleteOpen(!deleteOpen);
        getHeaderList();
        if (getValue(headerList, `length`, 0) === 1) {
          handleModal();
          setEditHeader(false);
        }
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                           Child Entity section                             */
  /* -------------------------------------------------------------------------- */
  const [editEntity, setEditEntity] = useState(false);
  const [isOpenChild, setIsOpenChild] = useState(false);
  const [parent_index, setParent_index] = useState<Number | unknown>(null);
  const [parent_info, setParent_info] = useState({});

  /* ---------------------------    Edit section     -------------------------------- */

  const handleModalChild = (item: any, index: number) => {
    setParent_info(item);
    setParent_index(index);
    setIsOpenChild(!isOpenChild);
  };

  const handleModalCancelChild = () => {
    setIsOpenChild(!isOpenChild);
  };

  const handleEditEntity = (
    e: any,
    item: object,
    parent_index: number,
    index: number,
    parent_info: any
  ) => {
    e.stopPropagation();
    setEditEntity(true);
    setParent_info({
      ...parent_info,
      id: getValue(parent_info, `id`, ""),
      group_name: getValue(parent_info, `group_name`, ""),
      group_level: getValue(parent_info, `group_level`, ""),
      entity_id: getValue(item, `id`, ""),
      entity_logo: getValue(item, "entity_logo", ""),
      entity_name: getValue(item, `entity_name`, ""),
      is_active: getValue(item, `is_active`, ""),
      entity_parent: getValue(item, `entity_parent`, ""),
    });
    setParent_index(parent_index);
    handleModalCancelChild();
  };

  /* ---------------------------    Delete section     -------------------------------- */

  const [deleteOpen1, setDeleteOpen1] = useState(false);
  const [deleteId1, setDeleteId1] = useState("");
  const [deleteValue1, setDeleteValue1] = useState("");
  const [deleteInfo, setDeleteInfo] = useState({
    parent_id: "",
    parent_index: "",
    parent_entity_id: "",
  });
  const handleDeleteModal1 = (
    e: any,
    item: any,
    parent_id: string,
    parent_index: any,
    selected_id: any
  ) => {
    e.stopPropagation();
    setDeleteInfo({
      ...deleteInfo,
      parent_id: parent_id,
      parent_entity_id: selected_id,
      parent_index: parent_index,
    });
    if (getValue(item, `id`, "")) {
      setDeleteId1(getValue(item, `id`, ""));
      setDeleteValue1(getValue(item, `entity_name`, ""));
    }
    setDeleteOpen1(!deleteOpen1);
  };
  const handleDeleteFun1 = async () => {
    try {
      let resp = await deleteSpecificChildEntityGroup(deleteId1);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setDeleteOpen1(!deleteOpen1);

        // Api call for refetch data
        handleStateAfterDelete();
        getEntityList(
          getValue(deleteInfo, `parent_id`, ""),
          getValue(deleteInfo, `parent_entity_id`, "").split("_")[0]
        );
      }
    } catch (error) {}
  };

  const handleStateAfterDelete = () => {
    // appending child entity list that are presented in URL Params
    var result = Object.entries(childEntityList);
    var myNewArray: any =
      getValue(result, `length`, 0) > 0
        ? result.filter(function (item, index) {
            return (
              index <=
              parseInt(
                getValue(deleteInfo, `parent_entity_id`, "").split("_")[2]
              )
            );
          })
        : [];
    let obj: any = {};
    if (getValue(myNewArray, `length`, 0) > 0) {
      myNewArray.map((item: any) => {
        obj[item[0]] = item[1];
      });
    }
    let filtered =
      getValue(obj, `[${getValue(deleteInfo, "parent_id", "")}].length`, 0) > 0
        ? obj[getValue(deleteInfo, `parent_id`, "")].filter(
            (item: any) => item.id != deleteId1
          )
        : [];
    obj[getValue(deleteInfo, `parent_id`, "")] = filtered;
    setChildEntityList(obj);
    // deleting params if grater then current level selected by the user
    for (
      let i =
        parseInt(getValue(deleteInfo, `parent_entity_id`, "").split("_")[2]) +
        1;
      i < 10;
      i++
    ) {
      delete params[`level${i}`];
    }
    let payload = {
      ...params,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };
  /* ---------------------------    Update section     -------------------------------- */

  const handleChangeEntityStatus = async (
    e: any,
    id: string,
    status: boolean,
    parent_id: any,
    parent_index: any
  ) => {
    e.stopPropagation();
    let payload = {
      ids: [id],
      is_active: status,
    };
    // console.log(id, payload);
    try {
      let resp = await updateChildEntityGroupStatus(payload);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        // console.log(parent_id, parent_index);
        let parenetId = getValue(params, `level${parent_index}`, "");
        let splitParentId = parenetId && parenetId.split("_");
        let entityParent = splitParentId[0];
        getEntityList(parent_id, entityParent ? entityParent : "");
        // getEntityList(
        //   getValue(parent_info, `id`, ""),
        //   getValue(parent_info, `group_level`, "")
        //     ? getValue(
        //         params,
        //         `level${
        //           parseInt(getValue(parent_info, `group_level`, "")) - 1
        //         }`,
        //         ""
        //       ).split("_")[0]
        //     : ""
        // );
      } else {
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                           Onclick Child Entity                             */
  /* -------------------------------------------------------------------------- */

  const handleClickEntity = (
    entity_id: any,
    group_id: any,
    group_level: any
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    //user selected level
    let userLevel = `${entity_id}_${group_id}_${group_level}`;
    let payload = { ...params };
    let selectedLevels =
      Object.values(payload).length > 0 ? Object.values(payload) : [];
    if (!selectedLevels.includes(userLevel)) {
      // appending child entity list that are presented in URL Params
      var result = Object.entries(childEntityList);
      var myNewArray: any =
        getValue(result, `length`, 0) > 0
          ? result.filter(function (item, index) {
              return index + 1 <= group_level;
            })
          : [];
      let obj: any = {};
      if (getValue(myNewArray, `length`, 0) > 0) {
        myNewArray.map((item: any) => {
          obj[item[0]] = item[1];
        });
      }
      setChildEntityList(obj);

      //deleting params if grater then current level selected by the user
      for (let i = group_level + 1; i < 10; i++) {
        delete params[`level${i}`];
      }

      // replacing url param if it have same group level / else we can add new one
      let checkIfAlreadyExist =
        Object.keys(payload).length > 0
          ? Object.keys(payload).includes(`level${group_level}`)
          : false;

      let currentLevel = params[`level${group_level}`];
      let page_no = currentLevel ? currentLevel.split("_")[3] : 1;
      let page_size = currentLevel ? currentLevel.split("_")[4] : 10;
      let search_text = currentLevel ? currentLevel.split("_")[5] : "";
      if (checkIfAlreadyExist) {
        delete params[`level${group_level}`];
        let obj = {
          ...params,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}_${
            page_no ? page_no : 1
          }_${page_size ? page_size : 10}_${search_text ? search_text : ""}`,
        };
        let queryRequest = QueryRequestHelper(obj);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        let obj = {
          ...params,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}_${
            page_no ? page_no : 1
          }_${page_size ? page_size : 10}_${search_text ? search_text : ""}`,
        };
        let queryRequest = QueryRequestHelper(obj);
        navigate(`${window.location.pathname}?${queryRequest}`);
      }
    } else {
      // toast.error("Already selected");
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                              Pagination Section                            */
  /* -------------------------------------------------------------------------- */

  const handleChangePagination = (e: any, level: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let currentLevel = getValue(params, `level${level}`, "");
    let entity_ID = currentLevel ? currentLevel.split("_")[0] : "";
    let group_ID = currentLevel ? currentLevel.split("_")[1] : "";
    let group_level = currentLevel ? currentLevel.split("_")[2] : "";
    let page_size = currentLevel ? currentLevel.split("_")[4] : "10";
    let search_text = currentLevel ? currentLevel.split("_")[5] : "";
    let obj = {
      ...params,
      [`level${level}`]: `${entity_ID}_${group_ID}_${group_level}_${e}_${
        page_size ? page_size : ""
      }_${search_text ? search_text : ""}`,
    };
    let queryRequest = QueryRequestHelper(obj);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };
  const handleChangeLimit = (e: any, level: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let currentLevel = getValue(params, `level${level}`, "");
    let entity_ID = currentLevel ? currentLevel.split("_")[0] : "";
    let group_ID = currentLevel ? currentLevel.split("_")[1] : "";
    let group_level = currentLevel ? currentLevel.split("_")[2] : "";
    let page_no = currentLevel ? currentLevel.split("_")[3] : "1";
    let search_text = currentLevel ? currentLevel.split("_")[5] : "";
    let obj = {
      ...params,
      [`level${level}`]: `${entity_ID}_${group_ID}_${group_level}_${
        page_no ? page_no : ""
      }_${e}_${search_text ? search_text : ""}`,
    };
    let queryRequest = QueryRequestHelper(obj);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeSearch = (e: any, level: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let currentLevel = getValue(params, `level${level}`, "");
    let entity_ID = currentLevel ? currentLevel.split("_")[0] : "";
    let group_ID = currentLevel ? currentLevel.split("_")[1] : "";
    let group_level = currentLevel ? currentLevel.split("_")[2] : "";
    let page_no = "1";
    let page_size = currentLevel ? currentLevel.split("_")[4] : "10";
    let obj = {
      ...params,
      [`level${level}`]: `${entity_ID}_${group_ID}_${group_level}_${
        page_no ? page_no : 1
      }_${page_size ? page_size : 10}_${getValue(e, `target.value`, "")}`,
    };
    let queryRequest = QueryRequestHelper(obj);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };
  const handleSpace = (e: any, level: string) => {
    let levelObj: any = {};
    let length = Object.values(params).length;
    for (let i = 0; i < length ? length : 0; i++) {
      levelObj[`level${i + 1}`] = level;
    }

    let key = Object.keys(levelObj).length;
    // if ((e.key === " " || e.keyCode === 32) && key === 1) {
    if (e.key === " " || e.keyCode === 32) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let currentLevel = getValue(params, `level${level}`, "");
      let entity_ID = currentLevel ? currentLevel.split("_")[0] : "";
      let group_ID = currentLevel ? currentLevel.split("_")[1] : "";
      let group_level = currentLevel ? currentLevel.split("_")[2] : "";
      let page_no = "1";
      let page_size = currentLevel ? currentLevel.split("_")[4] : "10";
      let search_text =
        (currentLevel ? currentLevel.split("_")[5] : "") + "%20";

      let obj = {
        ...params,
        [`level${level}`]: `${entity_ID}_${group_ID}_${group_level}_${
          page_no ? page_no : 1
        }_${page_size ? page_size : 10}_${search_text}`,
      };
      let queryRequest = QueryRequestHelper(obj);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };

  // const handleSpace = (e: React.KeyboardEvent<HTMLDivElement>, level: string) => {
  //   if (e.key !== " " && e.keyCode !== 32) return;

  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());

  //   let currentLevel = getValue(params, `level${level}`, "");
  //   let entity_ID = currentLevel ? currentLevel.split("_")[0] : "";
  //   let group_ID = currentLevel ? currentLevel.split("_")[1] : "";
  //   let group_level = currentLevel ? currentLevel.split("_")[2] : "";
  //   let page_no = "1";
  //   let page_size = currentLevel ? currentLevel.split("_")[4] : "10";
  //   let search_text = (currentLevel ? currentLevel.split("_")[5] : "") + "%20";

  //   let obj = {
  //       ...params,
  //       [`level${level}`]: `${entity_ID}_${group_ID}_${group_level}_${page_no}_${page_size}_${search_text}`,
  //   };

  //   let queryRequest = QueryRequestHelper(obj);
  //   navigate(`${window.location.pathname}?${queryRequest}`);
  // };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  /* -------------------------------------------------------------------------- */
  /*                             Download Reports                               */
  /* -------------------------------------------------------------------------- */
  const [downloadLoading, setDownloadLoading] = useState(false);
  const download = () => {};
  const handleDownloadSelfComplianceReport = async () => {
    try {
      let payload = {
        report_type: "ENTITY_MAPPING",
        report_name: "Entity Mapping",
        // report_description: "string",
        entity_group: 0,
        status: "active",
        entity_parent: 0,
      };
      setDownloadLoading(true);
      let resp = await exportEntityMapping(payload);
      if (resp) {
        // console.log(resp);
        setDownloadLoading(false);
        navigate(`/self-compliance-logs/ENTITY_MAPPING`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };
  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "configuration_mapping_entity_mapping"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="dashboard-wrapper__header d-flex justify-content-between align-items-center d-none">
            <h4 className="dashbaord-wrapper__header-title">Entity Mapping</h4>

            <div className="d-flex">
              <div
                className="d-flex"
                style={{ marginRight: "10px", alignItems: "center" }}
              >
                <BulkUploadDropdown dropdownOptions={dropdownOptions} />
                <BulkDownloadDropdown
                  dropdownOptions={dropdownOptions}
                  handleDownloadSelfComplianceReport={
                    handleDownloadSelfComplianceReport
                  }
                />
                {/* <div
                  className="add-filter-wrapper__filter-container"
                  onClick={
                    !downloadLoading
                      ? handleDownloadSelfComplianceReport
                      : download
                  }
                >
                  <img
                    src="/images/download-gray.svg"
                    style={{
                      height: "24px",
                      width: "24px",
                      margin: "0px auto",
                      marginLeft: "22px",
                      marginRight: "10px",
                    }}
                    // className="img-fluid add-filter-wrapper__upload-image"
                  />
                  <p className="add-filter-wrapper__filter-title">
                    {downloadLoading ? "Please wait..." : "DOWNLOAD"}
                  </p>
                </div> */}
              </div>

              {getValue(headerList, `length`, 0) > 0 && (
                <button
                  className={`ascent-button ascent-button--header-buttons ascent-button--secondary`}
                  onClick={handleEditGroupHeader}
                >
                  Edit Entity Header
                </button>
              )}
            </div>
          </div>

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MoreConfigSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Mapping
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  Entity Mapping
                </h4>
              </div>
            </div>

            <div className="d-flex justify-content-center align-items-center">
              {getValue(headerList, `length`, 0) > 0 && (
                // <button
                //   className={`ascent-button ascent-button--header-buttons ascent-button--secondary`}
                //   onClick={handleEditGroupHeader}
                // >
                //   Edit Entity Header
                // </button>

                <h6
                  className="ms-3 me-1 header_text__blue cursor-pointer"
                  onClick={handleEditGroupHeader}
                >
                  Edit Entity Header
                </h6>
              )}
              <div
                className="sub-header-icons-holder d-flex  sub-header-icons-left-line-seperator justify-content-center align-items-center"
                // style={{ marginRight: "10px", alignItems: "center" }}
              >
                <BulkUploadDropdown dropdownOptions={dropdownOptions} />
                <BulkDownloadDropdown
                  dropdownOptions={dropdownOptions}
                  handleDownloadSelfComplianceReport={
                    handleDownloadSelfComplianceReport
                  }
                />
              </div>
            </div>
          </div>

          {isLoading ? (
            <Loader />
          ) : getValue(headerList, `length`, 0) > 0 ? (
            <div className="main-page-layout-wrapper">
              <section className="list-managemnet-wrapper d-flex align-items-flex-start">
                {headerList.map((item: object, index: number) => {
                  let allParamsLevels = Object.keys(params);
                  let levels: any =
                    getValue(allParamsLevels, `length`, 0) > 0
                      ? allParamsLevels.map((item: any) =>
                          parseInt(item.split(`level`)[1])
                        )
                      : [];
                  let maxLevelUserSelected = Math.max(...levels);
                  let currentLevel = getValue(
                    params,
                    `level${getValue(item, `group_level`, "")}`,
                    ""
                  );
                  let page_no = currentLevel ? currentLevel.split("_")[3] : 1;
                  let page_size = currentLevel
                    ? currentLevel.split("_")[4]
                    : 10;
                  let search_text = currentLevel
                    ? currentLevel.split("_")[5]
                    : "";
                  return (
                    <div
                      className="list-managemnet-wrapper__country-table w-100"
                      key={index}
                    >
                      <div className="list-managemnet-wrapper__country-common-container">
                        {getValue(props, `permissions`, []).includes(
                          "create"
                        ) && (
                          <div
                            className="list-managemnet-wrapper__form-group form-group"
                            onClick={() =>
                              (index === 0 ||
                                maxLevelUserSelected + 1 >=
                                  getValue(item, `group_level`, "")) &&
                              handleModalChild(item, index)
                            }
                          >
                            <input
                              // type="text"
                              placeholder={`Add ${getValue(
                                item,
                                `group_name`,
                                ""
                              )}`}
                              className="form-control list-managemnet-wrapper__form-control"
                              disabled
                              style={{
                                backgroundColor:
                                  (index === 0 || maxLevelUserSelected + 1) >=
                                  getValue(item, `group_level`, "")
                                    ? "white"
                                    : "",
                              }}
                            />
                            <div className="list-managemnet-wrapper__form-add-icon">
                              <img
                                src="/images/add-red-btn.svg"
                                className="img-fluid"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="d-flex justify-content-between">
                        <h5 className="list-managemnet-wrapper__title">
                          {getValue(item, `group_name`, "")}
                        </h5>
                        {getValue(
                          params,
                          `level${getValue(item, `group_level`, "")}`,
                          ""
                        ) && (
                          <section
                            className="common-search-wrapper__filter d-flex align-items-center"
                            style={{ marginRight: "20px" }}
                          >
                            <div className="common-search-wrapper__filter-form-group form-group m-0">
                              <input
                                type="text"
                                placeholder={"Search here"}
                                className="common-search-wrapper__filter-search-input"
                                value={search_text}
                                autoComplete="off"
                                onChange={(e: any) =>
                                  handleChangeSearch(
                                    e,
                                    getValue(item, `group_level`, "")
                                  )
                                }
                                onKeyUp={(e: any) =>
                                  handleSpace(
                                    e,
                                    getValue(item, `group_level`, "")
                                  )
                                }
                              />
                              <img
                                src="/images/search.svg"
                                className="img-fluid common-search-wrapper__filter-input-image"
                              />
                              {search_text && (
                                <img
                                  src="/images/close-black.svg"
                                  className="img-fluid common-search-wrapper__filter-image-close"
                                  onClick={() => {
                                    handleChangeSearch(
                                      "",
                                      getValue(item, `group_level`, "")
                                    );
                                  }}
                                />
                              )}
                            </div>
                          </section>
                        )}
                      </div>
                      <div className="list-managemnet-wrapper__scroll">
                        {isLoading || !props.permissionAPITriggered ? (
                          <Loader />
                        ) : getValue(
                            childEntityList,
                            `[${getValue(item, `id`, "")}].length`,
                            0
                          ) > 0 ? (
                          getValue(
                            childEntityList,
                            `[${getValue(item, `id`, "")}]`,
                            []
                          ).map((entityObj: object, key: number) => {
                            return (
                              <EntityMappingOptions
                                item={entityObj}
                                key={key}
                                permissions={props.permissions}
                                handleEditEntity={handleEditEntity}
                                handleDeleteEntity={handleDeleteModal1}
                                parent_index={index}
                                index={key}
                                parent_info={item}
                                handleChangeStatus={handleChangeEntityStatus}
                                handleClickEntity={handleClickEntity}
                                selected_id={
                                  getValue(item, `group_level`, 0) > 0
                                    ? getValue(
                                        params,
                                        `level${
                                          parseInt(
                                            getValue(item, `group_level`, "")
                                          ) - 1
                                        }`,
                                        ""
                                      )
                                    : ""
                                }
                              />
                            );
                          })
                        ) : (
                          <p className="text-center mt-2">
                            {/* {isLoading1?'Please wait...':'Please Click on Entity to Get Data / No Data Found'} */}
                            Please Click on Entity to Get Data / No Data Found
                          </p>
                        )}
                        <div className="footer-wrapper_main d-flex justify-content-between mt-5">
                          {getValue(
                            paginationObj,
                            `[${getValue(item, `id`, "")}]`,
                            0
                          ) > 10 &&
                          getValue(
                            params,
                            `level${getValue(item, `group_level`, "")}`,
                            ""
                          ) ? (
                            <PaginationPage
                              totalCount={getValue(
                                paginationObj,
                                `[${getValue(item, `id`, "")}]`,
                                0
                              )}
                              limit={page_size ? parseInt(page_size) : 10}
                              pageNumber={page_no ? parseInt(page_no) : 1}
                              optimize={"false"}
                              handleChangePagination={(e: any) =>
                                handleChangePagination(
                                  e,
                                  getValue(item, `group_level`, "")
                                )
                              }
                              handleChangeLimit={(e: any) =>
                                handleChangeLimit(
                                  e,
                                  getValue(item, `group_level`, "")
                                )
                              }
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </section>
            </div>
          ) : (
            <div className="main-page-layout-wrapper">
              <ConfigEntityNotfound handleModal={handleModal} />
            </div>
            // <div className="list-management-add-entity">
            //   <p>No Entity Mapping Added, Please Add</p>
            //   <div className="items" onClick={handleModal}>
            //     <div className="list-managemnet-wrapper__form-add-icon">
            //       <img
            //         src="/images/add-red-btn.svg"
            //         className="img-fluid"
            //         style={{ height: "40px", width: "40px" }}
            //       />
            //     </div>
            //     <h5>Add Entity Mapping</h5>
            //   </div>
            // </div>
          )}

          <AddEntity
            isOpen={isOpen}
            handleModal={handleModal}
            handleModalCancel={handleModalCancel}
            headerList={headerList}
            editHeader={editHeader}
            handleDeleteModal={handleDeleteModal}
            handleEditHeader={handleEditHeader}
            getHeaderList={getHeaderList}
          />
          <DeleteModal
            isOpen={deleteOpen}
            handleModal={() => setDeleteOpen(!deleteOpen)}
            handleSubmit={handleDeleteFun}
            deleteValue={deleteValue}
          />
          <DeleteModal
            isOpen={deleteOpen1}
            handleModal={() => setDeleteOpen1(!deleteOpen1)}
            handleSubmit={handleDeleteFun1}
            deleteValue={deleteValue1}
          />

          <AddChildGroupEntity
            isOpen={isOpenChild}
            handleModal={handleModalCancelChild}
            handleModalCancel={handleModalCancelChild}
            parent_info={parent_info}
            parent_index={parent_index}
            getEntityList={getEntityList}
            editEntity={editEntity}
            setEditEntity={setEditEntity}
            paramsValue={
              getValue(parent_info, `group_level`, "")
                ? getValue(
                    params,
                    `level${
                      parseInt(getValue(parent_info, `group_level`, "")) - 1
                    }`,
                    ""
                  )
                : ""
            }
            childEntityList={childEntityList}
          />
        </>
      )}
    </DashboardLayout>
  );
};

export default EntityMapping;
